import { useEffect } from 'react';

const KeyboardNav = () => {
  useEffect(() => {
    const sections = [
      'hero',
      'about',
      'services',
      'calculator',
      'stats',
      'before-after',
      'tara',
      'contact'
    ];

    let currentSectionIndex = 0;

    const scrollToSection = (index) => {
      const section = document.getElementById(sections[index]);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        currentSectionIndex = index;
      }
    };

    const findCurrentSection = () => {
      const scrollPosition = window.pageYOffset + window.innerHeight / 2;

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section && section.offsetTop <= scrollPosition) {
          currentSectionIndex = i;
          break;
        }
      }
    };

    const handleKeyPress = (e) => {
      // Ignore if user is typing in an input field
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
        return;
      }

      switch(e.key) {
        case 'ArrowDown':
        case 'j':
          e.preventDefault();
          findCurrentSection();
          if (currentSectionIndex < sections.length - 1) {
            scrollToSection(currentSectionIndex + 1);
          }
          break;
        case 'ArrowUp':
        case 'k':
          e.preventDefault();
          findCurrentSection();
          if (currentSectionIndex > 0) {
            scrollToSection(currentSectionIndex - 1);
          }
          break;
        case 'Home':
          e.preventDefault();
          scrollToSection(0);
          break;
        case 'End':
          e.preventDefault();
          scrollToSection(sections.length - 1);
          break;
        default:
          break;
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    // Update current section on scroll
    window.addEventListener('scroll', findCurrentSection);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
      window.removeEventListener('scroll', findCurrentSection);
    };
  }, []);

  return null; // This component doesn't render anything
};

export default KeyboardNav;
